<template>
	<div class="main">
		<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
						<div class="bootbox-body">
							<section class="panel">
								<div class="panel-body">
									<div class="row form-group">
										<div class="col-md-12">
											<label>宿舍</label>
											<input v-model="popupParam.bedFloor" type="text" class="form-control" maxlength="20">
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-6">
											<label>房間</label>
											<input v-model="popupParam.bedRoom" type="text" class="form-control" maxlength="10">
										</div>
										<div class="col-md-6">
											<label>床位</label>
											<input v-model="popupParam.bed" type="text" class="form-control" maxlength="10">
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>房型</label>
											<input v-model="popupParam.bedCategory" type="text" class="form-control" maxlength="20">
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-6">
											<label>資訊盒</label>
											<input v-model="popupParam.infoBoxNo" type="text" class="form-control" maxlength="30">
										</div>
										<div class="col-md-6">
											<label>IP</label>
											<input v-model="popupParam.ipAddr" type="text" class="form-control" maxlength="30">
										</div>
									</div>
									<div>
										<div class="col-md-offset-3 col-md-3">
											<a href="javascript:;" class="btn s_btn_b btn-block" @click="closePopup()">返回</a>
										</div>
										<div class="col-md-3">
											<a href="javascript:;" class="btn btn-primary btn-block" @click="save()">儲存</a>
										</div>
									</div>
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['bedForm'],
	data(){
		return {
			popupParam: {}
		};
	},
	mounted(){
		this.popupParam = Object.assign({}, this.bedForm);
	},
	methods:{
		closePopup() {
			this.$parent.closeManualBedEdit();
		},
		save(){
			this.$parent.saveManualBedEdit(this.popupParam);
		}
	}
};
</script>
